// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".winter-video .x{background:#fff;z-index:9999999999;position:fixed;width:100vw;top:0;padding:5px 15px;display:flex;justify-content:space-between}.winter-video .x span,.winter-video .x i{display:flex;align-items:center;justify-content:center;font-size:16px;color:var(--accent-bg)}.winter-video .x i{cursor:pointer}.winter-video iframe{position:fixed;top:34px;bottom:0;width:100vw;z-index:999999999;height:calc(100vh - 34px)}", ""]);
// Exports
module.exports = exports;
